import { Text, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconSend } from "@tabler/icons";
import { MyButton } from "../../UI/my-button/MyButton";
import { useColors } from "../../../hooks/colors/useColors";
import { useState } from "react";
import { useFirebaseAuth } from "../../../hooks/firebase/useFirebaseAuth";
import { useTranslation } from "next-i18next";
import { useToastStore } from "../../config/store/toastStore";

export function ForgotPassword() {
  const { colors } = useColors();
  const { sendPasswordReset } = useFirebaseAuth();
  const [error, setError] = useState<string>("");
  const [processing, setProcessing] = useState<boolean>(false);
  const { t } = useTranslation("common");
  const { setToast } = useToastStore();

  const form = useForm({
    initialValues: {
      email: "",
    },
    validate: {
      email: (value) =>
        /^\S+@\S+$/.test(value) ? null : t("login.invalidEmail"),
    },
  });

  async function resetPassword(form: { email: string }) {
    setProcessing(true);
    setError("");
    try {
      const serverResponse = await sendPasswordReset(form.email);
      if (serverResponse === "SUCCESS") {
        setToast(t("success"), t("login.recovery-success"), 20000);
      } else if (serverResponse === "NOT_FOUND") {
        // @ts-ignore
        setError(t("login.submit-error"));
      } else {
        // @ts-ignore
        setError(t("submit-error"));
      }
      setProcessing(false);
    } catch (err) {
      console.error(err);
      setProcessing(false);
    }
  }

  return (
    <form onSubmit={form.onSubmit((values) => resetPassword(values))}>
      <TextInput
        error={form.errors.email}
        withAsterisk
        className="mb-4"
        type="text"
        label="Email"
        placeholder="your@email.com"
        {...form.getInputProps("email")}
      />
      {error.length > 1 && <Text color={colors.danger}>{error}</Text>}
      <MyButton
        disabled={processing}
        loading={processing}
        icon={<IconSend />}
        submit
        className="w-full mt-4"
        title={t("login.recover")}
        textColor="white"
        color={colors.primary}
        onClick={() => {}}
      />
    </form>
  );
}
